export const TIMEFRAME_PERIOD = {
    REPORT_PERIOD: 'REPORT_PERIOD',
    LTM: 'LTM',
} as const;

export const TIMEFRAME_PERIODS = Object.values(TIMEFRAME_PERIOD);
